var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero'),_c('Values'),_c('Champions'),_c('Portfolio'),(false)?_c('div',[_c('Contact')],1):_vm._e(),_c('MiniTachi15'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }